import { IState } from './types';

export const state: IState = {
  token: '',
  isAvailable: false,
  plan: null,
};
